import React from 'react';

import { Flex } from '@sopranodesign/pulse-components';

const Actions = () => {
  return <Flex top xSpace id="section-actions" />;
};

export default Actions;
